import type { PartnerAddress } from "@/app/api/types/partner";

export type AddressLineId =
  | "address_1"
  | "address_2"
  | "city"
  | "state"
  | "country";

export interface AddressLine {
  id: AddressLineId;
  text: string;
}

export const buildAddressLines = (
  address: PartnerAddress | null,
): AddressLine[] => {
  if (!address) return [];
  const cityLine = [address.zip_code, address.city]
    .filter((p) => p && p.trim().length > 0)
    .join(" ");
  const candidates: Array<[AddressLineId, string | null | undefined]> = [
    ["address_1", address.address_1],
    ["address_2", address.address_2],
    ["city", cityLine || null],
    ["state", address.state],
    ["country", address.country],
  ];
  return candidates.flatMap(([id, value]) =>
    value && value.trim().length > 0 ? [{ id, text: value }] : [],
  );
};

export const formatAddressLabel = (
  address: Pick<PartnerAddress, "name" | "code">,
): string => {
  const code = address.code?.trim();
  return code && code.length > 0 ? `${code} - ${address.name}` : address.name;
};
